export default {"src":"/_next/static/media/xgboost.ce4f3649.svg","height":1024,"width":1024};